var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 199,
    viewBox: "0 0 190 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18234_94778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.293 128.362L96.275 117.345C102.943 113.34 108.8 108.135 113.555 102.022L131.803 120.27C123.98 122.617 117.845 128.737 115.468 136.53",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.963 183.405C163.048 174.833 169.49 167.978 177.875 165.338",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.552 36.2325C121.512 36.0375 122.502 35.9325 123.522 35.9325C131.637 35.9325 138.222 42.5175 138.222 50.6325C138.222 57.645 133.317 63.5025 126.755 64.9725",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43 31.6425C88.415 34.5525 81.89 43.02 81.89 53.0025C81.89 65.4 91.94 75.45 104.338 75.45C105.41 75.45 106.475 75.375 107.51 75.2325",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.835 153.098C76.985 152.528 77.0675 151.935 77.0675 151.328C77.0675 147.563 74.015 144.51 70.25 144.51C66.485 144.51 63.4325 147.563 63.4325 151.328C63.4325 153.255 64.235 155.003 65.525 156.24",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.412 39.9075C169.897 39.9075 174.342 35.4617 174.342 29.9775C174.342 24.4933 169.897 20.0475 164.412 20.0475C158.928 20.0475 154.482 24.4933 154.482 29.9775C154.482 35.4617 158.928 39.9075 164.412 39.9075Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.86 51.0975V70.2075",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.415 60.6526H150.305",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8551 153.203V172.688",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5976 162.945H11.1125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2375 64.5451C29.4425 51.7426 35.6674 40.1176 45.5899 33.4351",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.13 29.9774C55.4825 28.6424 59.0975 27.8099 62.9 27.5699",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4475 122.85C94.4525 119.415 103.715 113.4 111.193 104.88C134.045 78.8249 131.45 39.1799 105.395 16.3274C97.73 9.59995 88.8725 5.07745 79.625 2.71495C57.455 -2.96255 32.96 3.73495 16.835 22.1249C14.435 24.8624 12.32 27.7424 10.4825 30.7424C-5.22998 56.3174 -0.692484 90.2325 22.6325 110.685C31.505 118.47 41.945 123.3 52.7675 125.257C60.4175 126.645 68.255 126.592 75.86 125.13M36.0725 23.4374C54.065 10.8674 78.9575 11.6699 96.2 26.7899C98.7575 29.0324 101.015 31.4699 102.988 34.0799C116.668 52.1699 116.263 77.9699 100.715 95.6924C82.9325 115.965 52.085 117.982 31.8125 100.207C22.46 92.0025 16.985 81.0224 15.56 69.5699C13.8875 56.2124 17.72 42.2249 27.2975 31.3124",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.618 152.745C103.265 152.88 92.1575 154.23 80.45 156.862C80.2475 156.907 80.0451 156.952 79.8426 157.005C74.0301 158.332 68.5026 159.877 63.3726 161.58C41.8176 168.727 27.3125 178.56 28.97 185.925C31.0325 195.112 57.4401 196.995 87.9351 190.125C90.2826 189.6 92.585 189.03 94.835 188.43",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.238 172.365C130.445 173.722 128.345 175.08 125.983 176.415",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.657 197.708C118.314 197.708 123.71 192.311 123.71 185.655C123.71 178.999 118.314 173.603 111.657 173.603C105.001 173.603 99.605 178.999 99.605 185.655C99.605 192.311 105.001 197.708 111.657 197.708Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.445 131.347L185.743 162.652C187.918 164.82 188.983 167.865 188.638 170.917C187.355 182.212 178.685 191.25 167.458 192.997L166.385 193.162C163.205 193.657 159.98 192.6 157.7 190.327L117.343 149.97C115.13 147.757 114.065 144.637 114.47 141.532L114.605 140.512C114.785 139.147 115.078 137.812 115.468 136.53C117.845 128.737 123.98 122.617 131.803 120.27C132.98 119.917 134.195 119.647 135.44 119.475L136.715 119.295C139.85 118.852 143.008 119.91 145.25 122.152",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18234_94778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188.947,
    height: 198.465,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.71379350c3910234d857ac357476bca4.svg";
export { ForwardRef as ReactComponent };